import http from '@/utils/http';

const URL_BASE_ESPECIALISTA = '/contrato-originacao/especialista';

export function buscarEspecialistas() {
    return http.get({
        url: URL_BASE_ESPECIALISTA,
        lockScreen: false
    });
}

export function buscarEspecialistaPorId(id) {
    return http.get({
        url: `${URL_BASE_ESPECIALISTA}/${id}`,
        lockScreen: true,
        notify: {
            status: [500]
        }
    });
}

export function buscarEspecialistasPorFiltro({ filtro, pageable }) {
    const { page, size, sort, order } = pageable;

    return http.post({
        url: `${URL_BASE_ESPECIALISTA}/filtro?page=${page}&size=${size}&sort=${sort},${order}`,
        data: filtro,
        lockScreen: true,
        notify: {
            status: [500]
        }
    });
}

export function cadastrarEspecialista(input) {
    return http.post({
        url: `${URL_BASE_ESPECIALISTA}/cadastrar`,
        data: input,
        lockScreen: true,
        notify: {
            status: [500]
        }
    });
}

export function editarEspecialista(input) {
    return http.post({
        url: `${URL_BASE_ESPECIALISTA}/editar`,
        data: input,
        lockScreen: true,
        notify: {
            status: [500]
        }
    });
}

export function removerEspecialista(input) {
    return http.post({
        url: `${URL_BASE_ESPECIALISTA}/remover`,
        data: input,
        lockScreen: true,
        notify: {
            status: [500]
        }
    });
}

export default {
    buscarEspecialistas,
    buscarEspecialistaPorId,
    buscarEspecialistasPorFiltro,
    cadastrarEspecialista,
    editarEspecialista,
    removerEspecialista
};
